import { useQuery } from '@tanstack/react-query';

import getUpcomingLiveOverview from 'Api/host/getUpcomingLiveOverview';
import getHostScheduleOverviewResponse from './model/response/getHostScheduleOverviewResponse';

const useGetHostUpcomingScheduleOverview = () => {
  return useQuery({
    queryKey: ['host-upcoming-schedule-overview'],
    queryFn: async () => {
      const response = await getUpcomingLiveOverview();

      const data = await getHostScheduleOverviewResponse(response);

      return data;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetHostUpcomingScheduleOverview;
